import React from "react";
import { Building2, Home, Sparkles } from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      title: "Commercial Epoxy Flooring",
      description: "Professional epoxy flooring for commercial properties, designed to withstand heavy traffic while maintaining a clean and professional appearance.",
      image: "https://images.unsplash.com/photo-1771531072574-af6ed6b954c0?auto=format&fit=crop&w=800",
      icon: <Building2 className="w-8 h-8" />
    },
    {
      title: "Residential Epoxy Flooring",
      description: "High-quality epoxy flooring solutions for homes, including garages and interior spaces, offering durability, easy maintenance, and a modern finish.",
      image: "https://images.unsplash.com/photo-1635108198165-1773945e506e?auto=format&fit=crop&w=800",
      icon: <Home className="w-8 h-8" />
    },
    {
      title: "Concrete Coating & Custom Epoxy",
      description: "Concrete coating and custom epoxy finishes that protect surfaces, improve resistance, and deliver long-lasting performance with a polished look.",
      image: "https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5?auto=format&fit=crop&w=800",
      icon: <Sparkles className="w-8 h-8" />
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="h-1 w-16 bg-blue-600 mb-4 mx-auto"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover a wide range of professional solutions designed to meet your needs with quality, 
            reliability, and care
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  {service.icon}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;